
const CONTRAST_TEXT = "#fff";
const PRIMARY_BG = "#016a01";
const SECONDARY_BG = "#016a01";
const TABLE_BORDER_COLOR = "#e0e0e0";
export const UWStyle = {
 contrastText: CONTRAST_TEXT,
 primaryBG: PRIMARY_BG,
 secondaryBG:SECONDARY_BG,
 tableBorderColor:TABLE_BORDER_COLOR
}